/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { withRouter } from 'react-router';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import CorpusSearchPanel from '../panels/corpusSearch/CorpusSearchPanel';

const AcademicExpressionForm = props => (
  <div>
    <Route path={props.match.url} exact render={() => <CorpusSearchPanel />} />
  </div>
);

AcademicExpressionForm.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(AcademicExpressionForm);
